/**
 * HR Admin HTTP client for app-materio.
 * Mirrors app/src/lib/http.js — all feature API files import from "@/lib/http".
 */
import axios from "axios";
import { useAuthStore } from "@/stores/auth";

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? "",
  timeout: 30_000,
});

// Attach Firebase ID token on every request.
http.interceptors.request.use(async (config) => {
  const auth = useAuthStore();
  if (auth.idToken) {
    config.headers.Authorization = `Bearer ${auth.idToken}`;
  }
  return config;
});

// On 401 → sign out and bounce to login.
http.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      useAuthStore().signOut();
    }
    return Promise.reject(error);
  },
);
